module.exports = __webpack_public_path__ + "static/media/secretBanner.9a073856.png";